import {createFileRoute, redirect} from '@tanstack/react-router';
import {getDocs} from 'firebase/firestore';
import {getTeacherFeedbackRolesCollectionRef} from '@cip/core/firebase/client';
import {ForbiddenError} from '../../../errors';
import ZoomCallbackPage from '../../../pages/ZoomCallbackPage';

export const Route = createFileRoute('/_authenticated/zoom/callback')({
  async beforeLoad({context}) {
    const {user} = context.auth;
    // The _authenticated parent already redirects unauthenticated users, but
    // guard here as well in case this route is ever moved outside that layout.
    if (!user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirects
      throw redirect({to: '/sign-in'});
    }

    const rolesSnapshot = await getDocs(
      getTeacherFeedbackRolesCollectionRef({uid: user.uid}),
    );
    const isAdmin = rolesSnapshot.docs.some(doc => doc.data().role === 'admin');
    if (!isAdmin) {
      throw new ForbiddenError('Only admins can connect a Zoom account.');
    }
  },
  component: ZoomCallbackPage,
});
